const countryOptions = [{ value: 'Switzerland', label: 'Switzerland' }];

export default countryOptions;
